module.exports = __webpack_public_path__ + "static/media/volleyball.8898e76e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/volleyball.jpg
// module id = 698
// module chunks = 0